import { useState, useEffect, memo } from "react";
import { useRouter } from "next/router";
import { useTypedSelector } from "../../hooks/useTypedSelector";

type PropsAreEqual<P> = (
  prevProps: Readonly<P>,
  nextProps: Readonly<P>
) => boolean;

const withAuth = <P extends {}>(
  Component: React.ComponentType<P>,
  propsAreEqual?: PropsAreEqual<P> | false,
  componentName = Component.displayName ?? Component.name
): {
  (props: P): JSX.Element;
  displayName: string;
} => {
  const WithSampleHoc = (props: P) => {
    const router = useRouter();
    const isLoggedin = useTypedSelector(state => state.auth.isLoggedin);

    useEffect(() => {
      if (!(window && window.localStorage.getItem("token"))) {
        router.push("/login");
      }
    }, [router, isLoggedin]);

    if (!isLoggedin) {
      return <div />;
    }
    return <Component {...props} />;
  };

  WithSampleHoc.displayName = `withSampleHoC(${componentName})`;

  let wrappedComponent =
    propsAreEqual === false
      ? WithSampleHoc
      : memo(WithSampleHoc, propsAreEqual);

  return wrappedComponent as typeof WithSampleHoc;
};

export default withAuth;
